import { render, staticRenderFns } from "./TokenPricedDeprecatedToggleButton.vue?vue&type=template&id=aee47808"
import script from "./TokenPricedDeprecatedToggleButton.vue?vue&type=script&lang=ts"
export * from "./TokenPricedDeprecatedToggleButton.vue?vue&type=script&lang=ts"
import style0 from "./TokenPricedDeprecatedToggleButton.vue?vue&type=style&index=0&id=aee47808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports